import { render, staticRenderFns } from "./Visualizador.vue?vue&type=template&id=63bf0151&scoped=true"
import script from "./Visualizador.vue?vue&type=script&lang=js"
export * from "./Visualizador.vue?vue&type=script&lang=js"
import style0 from "./Visualizador.vue?vue&type=style&index=0&id=63bf0151&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63bf0151",
  null
  
)

export default component.exports